import React from "react";
import { useEffect, useRef, useContext } from "react";
import { ThreadContext } from "../../contexts/Thread/ThreadContext";
import { InformationBasicContext } from "../../contexts/InformationBasicContext/InformationBasicContext";
import { ChatContext } from "../../contexts/ChatContext/ChatContext"; 

const Thread = () => {
    const { HistoryThreads, GetHistoryThreads } = useContext(ThreadContext);
    const { companySelected } = useContext(InformationBasicContext);
    const { setThread_id } = useContext(ChatContext);
    
    const hasFetched = useRef(false);
    const scrollAuto = useRef(null);
    
    const selectThread = (thread) => {
        setThread_id(thread);
    };
    
    useEffect(() => {
        if (hasFetched.current) return;
        
        if (companySelected){
            GetHistoryThreads(companySelected);
            hasFetched.current = true;
        }
    }, [companySelected, GetHistoryThreads]);

    useEffect(() => {
        scrollAuto.current?.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, [HistoryThreads]);

    return (
        <div ref={scrollAuto} className="w-full pr-3 pl-3 lg:pl-5 pt-5 h-[calc(100vh-70px)] overflow-y-auto">
            {HistoryThreads.map((thread, index) => (
                <div 
                    className="pb-5 cursor-pointer" 
                    key={index}
                    onClick={() => selectThread(thread.thread_id)}
                >
                    <p className="text-sm text-gray-500 font-light">{thread.formatted_date}</p>

                    <p className="text-lg text-gray-[#000000] text-justify font-light">
                        {thread.question && thread.question.trim() !== ""
                            ? (thread.question.length > 35
                                ? thread.question.slice(0, 35) + "..."
                                : thread.question
                            ).charAt(0).toUpperCase() + 
                            (thread.question.length > 35
                                ? thread.question.slice(1, 35)
                                : thread.question.slice(1)
                            ).toLowerCase()
                            : "..."}
                    </p>
                </div>
             ))}             
        </div>
    );
  };
  
export default Thread;
  